import { cn } from '@/lib/utils';

type Condition = 'NEW' | 'USED' | 'CERTIFIED';

const CONDITION_CONFIG: Record<Condition, { label: string; className: string }> = {
  NEW:       { label: 'New',       className: 'bg-blue-100  text-blue-700'   },
  USED:      { label: 'Used',      className: 'bg-slate-100 text-slate-600'  },
  CERTIFIED: { label: 'CPO',       className: 'bg-teal-100  text-teal-700'   },
};

export function ConditionBadge({ condition }: { condition: string }) {
  const config = CONDITION_CONFIG[condition as Condition] ?? { label: condition, className: 'bg-slate-100 text-slate-600' };
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium', config.className)}>
      {config.label}
    </span>
  );
}
